export default function setUpEditQuantity () {
  const value = $("input[name='quantity']").val()
  $("input[name='quantityjs'], input[name='newamountjs']").val(isNaN(value) ? 0 : value)
}
